// extracted by mini-css-extract-plugin
export var chevron = "_gg-2";
export var dropdownItems = "_gg-0";
export var item = "_gg-1";